import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Landmark, Building2, GraduationCap, Home, ClipboardList, Utensils } from "lucide-react";

const ExpertiseSection = () => {
  const services = [
    {
      icon: Landmark,
      title: "Public Sector",
      description: "FM, cleaning, admin and support staff for councils, housing associations, NHS facilities, schools, probation and justice environments.",
      gradient: "bg-gradient-to-br from-blue-700 to-blue-500",
      href: "/sectors/public-sector",
    },
    {
      icon: Building2,
      title: "Corporate FM",
      description: "Cleaning operatives, FM coordinators and facilities support staff for commercial buildings, corporate estates and FM contractors nationwide.",
      gradient: "bg-gradient-to-br from-slate-700 to-slate-500",
      href: "/sectors/corporate-fm",
    },
    {
      icon: GraduationCap,
      title: "Education",
      description: "DBS-checked cleaning and support staff for schools, colleges and academies. Safeguarding-compliant supply, term-time and year-round.",
      gradient: "bg-gradient-to-br from-green-600 to-green-500",
    },
    {
      icon: Home,
      title: "Housing & Care",
      description: "Housing support workers, homelessness staff and care operatives for councils, housing associations and support services.",
      gradient: "bg-gradient-to-br from-purple-600 to-purple-400",
    },
    {
      icon: ClipboardList,
      title: "Admin & Business Support",
      description: "Business support officers, council admin and customer service staff for local government and public sector clients.",
      gradient: "bg-gradient-to-br from-orange-600 to-orange-500",
    },
    {
      icon: Utensils,
      title: "Hospitality & Retail",
      description: "Catering, front of house and retail staff for commercial clients across the UK.",
      gradient: "bg-gradient-to-br from-amber-600 to-amber-500",
    },
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="mb-6 inline-block rounded-full bg-primary/10 px-6 py-2 text-sm font-medium text-primary">
            Our Specialist Expertise
          </div>
          
          <h2 className="mb-6 text-4xl font-bold text-foreground md:text-5xl lg:text-6xl">
            People-Focused Recruitment Solutions
          </h2>
          
          <p className="mx-auto max-w-3xl text-lg text-muted-foreground md:text-xl">
            Delivering reliable and flexible staffing solutions across key sectors, nationwide.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => {
            const Icon = service.icon;
            const card = (
              <Card
                className={`group h-full border-border bg-card shadow-card transition-all hover:shadow-elevated hover:-translate-y-1 ${service.href ? "cursor-pointer" : ""}`}
              >
                <CardHeader>
                  <div className={`mb-4 inline-flex h-14 w-14 items-center justify-center rounded-xl ${service.gradient}`}>
                    <Icon className="h-7 w-7 text-white" />
                  </div>
                  <CardTitle className="text-xl text-card-foreground">{service.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-muted-foreground">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
            return service.href ? (
              <Link key={index} to={service.href} className="block h-full">{card}</Link>
            ) : (
              <div key={index} className="h-full">{card}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
